// ライブラリ
import polyfill from './inc/polyfill.js';

// ポリフィル
polyfill();

import touchDevice from './inc/touchDevice.js';
import CustomPropertyManager from './inc/CustomPropertyManager.js';
import MenuManager from './inc/MenuManager.js';
import hideOnScroll from './inc/HideOnScroll.js';

// ブラウザやデバイスなどの環境を判定（IEを判定してbodyタグにclass付与）
import EnvDetector from './inc/EnvDetector.js';
new EnvDetector();

import ScrollPerformanceOptimizer from './inc/ScrollPerformanceOptimizer.js';
new ScrollPerformanceOptimizer();

// スクロール状態の管理
import ScrollStateManager from './inc/ScrollStateManager.js';
new ScrollStateManager();

// Scroll Magicによるスクロール管理
import ScrollManager from './inc/ScrollManager.js';
new ScrollManager();

// Swiperによるスライダー管理
import SliderManager from './inc/SliderManager.js';
new SliderManager();

// タッチデバイス対応（ホバー挙動の再現など）
touchDevice();

// メインビジュアル動画
// mainVisual();

// swiperjs();

// CSSのカスタムプロパティを管理
new CustomPropertyManager();

// メニュー管理（ハンバーガーメニュー、モーダル）
new MenuManager();

// 要素をスクロール時に隠す
new hideOnScroll();

import TabManager from './inc/TabManager.js';
new TabManager();

import Accordion from './inc/Accordion.js';
document.querySelectorAll('details').forEach((el) => {
  new Accordion(el, el.classList.contains('is-open') ? true : false);
});

// 開発用の機能郡（本番公開時に削除する）
// import DevUtils from './inc/DevUtils.js';
// new DevUtils();

import VideoManager from './inc/VideoManager.js';
new VideoManager();

// ページごとの機能
import { HomePage } from '@pages/HomePage';
import { RecruitPage } from '@pages/RecruitPage';
document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname.includes('/')) {
    new HomePage();
  }

  if (window.location.pathname.includes('recruit')) {
    new RecruitPage();
  }
});

// 任意のコード
import Swiper from 'swiper/bundle';
document.addEventListener('DOMContentLoaded', function () {
  // CF7と入力状態パンくずがある場合
  if (document.querySelector('.wpcf7') && document.querySelector('.p-recruit-entry__step')) {
    // Contact Form 7の入力時、送信完了でis-currentを設定する
    const inputFields = document.querySelectorAll('.wpcf7-form-control');
    const stepElements = document.querySelectorAll('.p-recruit-entry__step li');

    // 入力が始まったら、'入力' ステップに 'is-current' クラスを追加
    inputFields.forEach(function(field) {
      field.addEventListener('input', function() {
        stepElements[0].classList.add('is-current');
        stepElements[2].classList.remove('is-current');
      });
    });

    document.addEventListener('wpcf7mailsent', function (event) {
      stepElements[0].classList.remove('is-current');
      stepElements[2].classList.add('is-current');
    }, false );
  }

  if (window.location.pathname.includes('recruit')) {

    const sliders = document.querySelectorAll('.p-recruit-culture__content-item-slide');

    sliders.forEach((slider) => {
      const parent = slider.closest('.p-recruit-culture__content-item');
      const pagination = parent.querySelector('.swiper-pagination');

      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        autoplay: {
          delay: 4000,
        },
        pagination: {
          el: pagination,
          clickable: true
        }
      });
    });
  }
});
